import {
  BoxProps,
  FormHelperTextProps,
  GridProps,
  StackProps,
  SxProps,
} from "@mui/material";
import muiVariables from "../../styles/mui-variables";

const dashboardModelStyle = {
  extraProductModelMainGrid: {
    maxWidth: "100%",
    overflow: "hidden",
    alignItems: { sm: "center", lg: "flex-start" },
    justifyContent: { sm: "center", lg: "flex-start" },
  } as GridProps,
  discountFormHelperText: {
    sx: {
      marginTop: "5px !important",
      paddingLeft: "5px !important",
      color: `${muiVariables.errorMessageColor}`,
    },
  } as FormHelperTextProps,
  mainButtonsBox: {
    height: "74px",
    width: "100%",
    bottom: "0",
    borderTop: `1px solid ${muiVariables.borderColor}`,
    sx: {
      position: "fixed",
      marginTop: { xs: 5, sm: 5 },
      backgroundColor: "rgb(255,255,255)",
    },
  } as BoxProps,
  mainButtonsSubBox: {
    sx: {
      display: "flex",
      flexDirection: "row",
      pt: 2,
      alignItems: "center",
    },
  } as BoxProps,
  mainButtonsPositionBox: {
    sx: {
      flex: "1 1 auto",
      mr: { lg: 3, sm: 3, md: 3 },
      textAlign: "end",
      padding: { xs: "0 16px 0 16px" },
    },
  } as BoxProps,
  mainBackBtnSx: {
    width: { xs: "100%", sm: "fit-content" },
    backgroundColor: muiVariables.primaryColor,
    borderColor: muiVariables.borderColor,
    color: muiVariables.mainTextColor,
    "&:hover": {
      borderColor: muiVariables.borderColor,
    },
  } as SxProps,
  mainSaveBtnSx: {
    width: { xs: "100%", sm: "fit-content" },
    whiteSpace: { xs: "nowrap" },
    backgroundColor: muiVariables.primaryBtnColor,
    borderColor: muiVariables.borderColor,
    color: `${muiVariables.primaryColor}`,
  } as SxProps,
  radioGroupWrap: {
    direction: { xs: "column", sm: "row" },
    alignItems: { xs: "", sm: "start" },
    spacing: 2,
  } as StackProps,
  radioStackGrid: {
    marginInlineStart: {
      xs: "",
      sm: "16px !important",
      md: "16px !important",
      lg: "16px !important",
    },
  } as GridProps,
  promoCodeModelBtnStack: {
    mt: 4,
    direction: "row",
    spacing: 2,
    alignItems: "center",
    justifyContent: "end",
  } as StackProps,
  promoCodeModelBtnCancelSx: {
    width: "fit-content",
    backgroundColor: muiVariables.primaryColor,
    borderColor: muiVariables.borderColor,
    color: muiVariables.mainTextColor,
    "&:hover": {
      borderColor: muiVariables.borderColor,
    },
  } as SxProps,
  promoCodeModelBtnUpdateSx: {
    width: "fit-content",
    backgroundColor: muiVariables.primaryBtnColor,
    borderColor: muiVariables.borderColor,
    color: `${muiVariables.primaryColor}`,
  } as SxProps,
  startDateFormHelperText: {
    sx: {
      marginTop: "5px !important",
      paddingLeft: "3px !important",
      paddingRight: "3px !important",
      textAlign: "start",
      color: `${muiVariables.errorMessageColor}`,
    },
  } as FormHelperTextProps,
};

export default dashboardModelStyle;
